import { httpClient } from '@/lib/http-client'

export interface Role {
    id: string
    name: string
    description: string
    is_system: boolean
    allowed_actions: string[]
    created_at: string
    user_count: number
}

export interface ActionGroups {
    [group: string]: string[]
}

export const rolesApi = {
    list: () => httpClient.get('/roles'),

    create: (data: { name: string; description?: string }) =>
        httpClient.post('/roles', data),

    update: (id: string, data: { name?: string; description?: string }) =>
        httpClient.put(`/roles/${id}`, data),

    delete: (id: string) => httpClient.delete(`/roles/${id}`),

    // Policy management
    getActions: () => httpClient.get<{ groups: ActionGroups }>('/roles/actions'),

    updatePolicy: (id: string, actions: string[]) =>
        httpClient.put(`/roles/${id}/policy`, { actions }),

    // User-role assignment
    listUsers: (roleId: string) =>
        httpClient.get(`/roles/${roleId}/users`),

    addUsers: (roleId: string, userIds: string[]) =>
        httpClient.post(`/roles/${roleId}/users`, { user_ids: userIds }),

    removeUser: (roleId: string, userId: string) =>
        httpClient.delete(`/roles/${roleId}/users/${userId}`),
    importData: (form: FormData) =>
        httpClient.post('/roles/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/roles/export?format=${format}`,
}
